import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { addPaymentMethod } from '@utils/backend-api/stripe';

const useAddPaymentMethod = () => {
  const { mutate, isLoading, isError } = useMutation(addPaymentMethod, {
    onSuccess: (data) => {
      window.location.href = data.redirect_to;
    },
    onError: (error: { message: string; redirect_to?: string }) => {
      toast.error(error.message);
      if (error.redirect_to) {
        window.location.href = error.redirect_to;
      }
    },
  });
  return { mutate, isLoading, isError };
};

export default useAddPaymentMethod;
